import classes from "./StatusMessage.module.css";
import { LoadingSpinner } from "../loadingSpinner/LoadingSpinner";

export function StatusMessage({ status, items, text }) {
  const shouldShow =
    status === "loading" || items?.length === 0 || status === "error";

  if (!shouldShow) return null;

  return (
    <div key={status} className={`${classes.container} fadeInTranslate`}>
      {status === "loading" && <LoadingSpinner black={true} />}
      {items?.length === 0 &&
        (status === "success" || status === "succeeded") &&
        text.noItemsFound}
      {status === "error" && text.errorFetching}
    </div>
  );
}
